import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import PopoverMenuPrefix from "./PopoverMenuPrefix";
import Heroicon from "././../../Heroicon";

function HeaderMenuPrefix({
  mainLinks,
  advancedLinks,
  adminLinks,
  supportLinks,
  gravatarUrl,
}) {
  const [gravatarLoaded, setGravatarLoaded] = useState("pending");

  function getInitials() {
    const nameArr = Castos.config.userName.toUpperCase().split(" ");
    const firstName = nameArr[0].charAt(0);
    const lastName = nameArr[1];

    if (nameArr.length > 1) {
      return firstName + lastName.charAt(0);
    } else {
      return firstName;
    }
  }

  return (
    <div className="tw-flex tw-justify-end tw-items-stretch lg:tw-gap-2 tw-min-h-[40px]">
      <button
        id="beamerButton"
        className="tw-px-3 tw-rounded-md tw-text-gray-600 tw-text-lg hover:tw-bg-purple-100 hover:tw-text-purple-700"
        aria-label="What's new"
      >
        <Heroicon icon="o-bell" style="tw-h-6 tw-w-6" />
      </button>
      <PopoverMenuPrefix
        button={
          <>
            <p className="tw-sr-only">Support docs</p>
            <Heroicon icon="o-lifebuoy" style="tw-h-6 tw-w-6" />
          </>
        }
        btnClass="focus:tw-ring-2 focus:tw-ring-purple-300 tw-px-3 hover:tw-bg-purple-100 hover:tw-text-purple-700 tw-rounded-md tw-h-full"
        panel={
          <nav className="md:tw-min-w-[380px] tw-space-y-3 tw-py-2 tw-text-gray-600 tw-text-base tw-divide-solid tw-divide-y tw-divide-gray-200">
            {supportLinks.map((elem, index) => (
              <section key={index} className="tw-px-4 tw-py-2.5 tw-space-y-4">
                <h2 className="tw-flex tw-font-bold tw-font-sans tw-gap-3 tw-items-center tw-text-gray-700 tw-text-lg">
                  <Heroicon
                    icon={elem.icon}
                    style="tw-w-5 tw-h-5 tw-text-gray-500"
                  />
                  {elem.title}
                </h2>
                <p className="tw-text-gray-500 tw-text-sm">{elem.text}</p>
                <a
                  href={elem.href}
                  target="_blank"
                  className="tw-flex tw-font-bold tw-gap-2 tw-items-center tw-text-purple-600 tw-text-sm hover:tw-underline"
                >
                  {elem.linkTitle}
                  <Heroicon icon="o-arrow-up-right" style="tw-w-4 tw-h-4" />
                </a>
              </section>
            ))}
          </nav>
        }
      />
      <PopoverMenuPrefix
        button={
          <>
            <p className="tw-sr-only">Account menu</p>
            <div className="tw-hidden md:tw-block" role="presentation">
              <img
                src={gravatarUrl}
                alt="Avatar"
                onError={() => setGravatarLoaded("failed")}
                onLoad={() => setGravatarLoaded("completed")}
                className={`tw-w-11 tw-h-auto lg:tw-h-11 tw-rounded-full ${
                  gravatarLoaded === "completed" ? "tw-block" : "tw-hidden"
                }`}
              />
              {gravatarLoaded === "pending" && (
                <div
                  aria-hidden="true"
                  className="tw-bg-gray-50 tw-grid tw-h-11 tw-place-content-center tw-rounded-full tw-w-11"
                ></div>
              )}
              {gravatarLoaded === "failed" && (
                <div
                  aria-hidden="true"
                  className="tw-bg-gradient-to-tl tw-font-medium tw-from-purple-500 tw-grid tw-h-11 tw-place-items-center tw-rounded-full tw-text-white tw-to-purple-700 tw-w-11"
                >
                  {getInitials()}
                </div>
              )}
            </div>
            <div className="md:tw-hidden">
              <Heroicon icon="o-bars-3" style="tw-h-6 tw-w-6" />
            </div>
          </>
        }
        btnClass="tw-px-3 tw-h-full focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-purple-300 hover:tw-bg-purple-100 hover:tw-text-purple-700 tw-rounded-md md:hover:tw-ring-2 md:tw-p-0 md:tw-mx-3 md:hover:tw-ring-purple-300 md:hover:tw-ring-offset-2 md:tw-rounded-full"
        panel={
          <nav className="tw-w-auto md:tw-min-w-[250px] tw-text-gray-700 tw-text-base">
            <div className="tw-divide-gray-200 tw-divide-solid tw-divide-y tw-items-center tw-text-sm sm:tw-text-base">
              <p className="tw-font-medium tw-px-4 tw-py-3 tw-text-gray-500 tw-text-sm">
                {Castos.config.userEmail}
              </p>
              <section className="md:tw-hidden">
                {mainLinks.map((elem, index) => (
                  <a
                    href={elem.href}
                    key={index}
                    className="btn-ghost-primary tw-capitalize tw-font-medium tw-px-4 tw-py-2.5 tw-rounded-none tw-transition-none"
                  >
                    {elem.text}
                  </a>
                ))}
              </section>
              <section>
                {advancedLinks.map((elem, index) => (
                  <a
                    href={elem.href}
                    key={index}
                    className="btn-ghost-primary tw-capitalize tw-flex tw-font-medium tw-gap-1 tw-px-4 tw-py-2.5 tw-rounded-none tw-transition-none"
                    target={elem.target}
                  >
                    {elem.text === "Revert Impersonate" && (
                      <Heroicon icon="o-eye-slash" style="tw-w-5 tw-h-5" />
                    )}
                    {elem.text}
                    {elem.text === "Share the" && (
                      <Heroicon
                        icon="s-heart"
                        style="tw-h-5 tw-w-5 tw-opacity-30 tw-ml-1 tw-mt-[2px]"
                      />
                    )}
                  </a>
                ))}
              </section>
              {adminLinks && (
                <section>
                  {adminLinks.map((elem, index) => (
                    <a
                      href={elem.href}
                      key={index}
                      className="btn-ghost-primary tw-capitalize tw-flex tw-font-medium tw-items-center tw-px-4 tw-py-2.5 tw-rounded-none tw-transition-none"
                    >
                      {elem.text}
                    </a>
                  ))}
                </section>
              )}
              <section>
                <a
                  href="/logout"
                  data-logout-link
                  className="btn-ghost-primary tw-flex tw-font-medium tw-gap-2 tw-items-center tw-px-4 tw-py-3 tw-rounded-none tw-text-gray-500 tw-transition-none hover:tw-text-purple-600 hover:tw-rounded-b-md"
                >
                  <Heroicon
                    icon="o-arrow-right-on-rectangle"
                    style="tw-w-5 tw-h-5"
                  />
                  Sign Out
                </a>
              </section>
            </div>
          </nav>
        }
      />
    </div>
  );
}

const initHeaderMenuPrefix = function (selector) {
  const elements = document.querySelectorAll(selector);

  if (elements.length > 0) {
    elements.forEach((element) => {
      const root = createRoot(element);
      const mainLinks = JSON.parse(element.dataset.mainlinks);
      const advancedLinks = JSON.parse(element.dataset.advancedlinks);
      const adminLinks = JSON.parse(element.dataset.adminlinks);
      const supportLinks = JSON.parse(element.dataset.supportlinks);
      const gravatarUrl = element.dataset.gravatarurl;
      root.render(
        <HeaderMenuPrefix
          mainLinks={mainLinks}
          advancedLinks={advancedLinks}
          adminLinks={adminLinks}
          supportLinks={supportLinks}
          gravatarUrl={gravatarUrl}
        />
      );
    });
  }
};

export { HeaderMenuPrefix as default, initHeaderMenuPrefix };
